const cover_page = ({
	agentNumber,
	currentDate,
	agentName,
	policyNumber,
	holderName,
	debitNumber,
	hasEndorsement
}) => {
	return `
  <!DOCTYPE html>

<html lang="en" xmlns="http://www.w3.org/1999/xhtml">

<head>
  <meta charset="utf-8" />
  <title>VHIS_Standard_Plan_-_Cover_Page</title>
  <style>
    .tal {
      text-align: left;
    }

    .tar {
      text-align: right;
    }

    .tac {
      text-align: center;
    }

    .bt {
      border-top: 1px solid black;
    }

    .bb {
      border-bottom: 1px solid black;
    }

    .ff-msjh {
      font-family: "Droid Sans";
    }

    .bbdot {
      border-bottom: 1px dotted black;
    }

    .width50pc {
      width: 50%;
    }

    .widthFixed {
      width: 100%;
    }

    .fs8 {
      font-size: 8pt;
    }

    .fs10 {
      font-size: 10pt;
    }

    .fw400 {
      font-weight: 400
    }

    .fw700 {
      font-weight: 700
    }

    p {
      font-size: 12pt;
      font-family: Arial;
      text-align: left;
    }

    table {
      border-collapse: collapse;
    }

    td {
      padding: 1px;
      width: 25%;
      line-height: 1.15;
    }

    .header__container {
      float: left;
      display: block;
      width: 100%;
      margin: 0 0 25px 0;
    }

    .header__image {
      width: 100%;
    }
  </style>
</head>

<body>
  <div style="margin: 0 auto;">
    <div align="center">
      <table class="widthFixed">
        <tr>
          <td>
            <p class="fw700 fs10">
              <span>Account No. :</span>
            </p>
          </td>
          <td>
            <p class="fs10 fw400"><span>${agentNumber}</span></p>
          </td>
          <td>
            <p class="fw700 fs10">
              Date:<br>
            </p>
          </td>
          <td>
            <p class="fs10 fw400"><span>${currentDate}</span></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="fw700 fs10">
              Agent:<br>
            </p>
          </td>
          <td>
            <p class="fs10 fw400">
              ${agentName}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="fw700 fs10">
              Policy No. :<br>
            </p>
          </td>
          <td>
            <p class="fs10 fw400">
              ${policyNumber}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="fw700 fs10">
              Policy Holder :<br>
            </p>
          </td>
          <td>
            <p class="fs10 fw400">
              ${holderName}
              </span>
            </p>
          </td>
        </tr>
      </table>


      <div class="widthFixed">
        <p>
          <span class="fw400 fs10">Dear Sirs/Madams,</span>
        </p>
        <p>
          <span class="fw400 fs10">
            Thank you for choosing Asia Insurance to be your medical insurance service provider.
          </span>
        </p>
        <p>
          <span class="fw400 fs10">
            We are pleased to enclose here with the following documents for your kind attentions:
          </span>
        </p>
      </div>


      <table class="widthFixed">
        <tr>
          <td>
            <p class="fw400 fs10">
              ☑︎ Premium Debit/ (Credit) Notes No. :
            </p>
          </td>
          <td class="bt bb">
            <p class="tac fw400 fs10">${debitNumber}</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="fw400 fs10">
              ☑︎ Policy Schedule
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="fw400 fs10">
              ☑︎ Copy of Application Form
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="fw400 fs10">
              ☑︎ Standardised Policy Terms and Conditions
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="fw400 fs10">
              ${hasEndorsement === true ? "☑︎" : "☐"} Endorsement
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="fw400 fs10">
              ☑︎ Benefit Schedule
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="fw400 fs10">
              ☑︎ Premium Schedule
            </p>
          </td>
        </tr>
      </table>

      <div class="widthFixed">
        <p class="fw400 fs10">
          Please kindly check the enclosed documents.<br>
          Should you have any question, please do not hesitate to contact our service hotline at 3606 9346 or<br>
          direct contact our marketing handlers for further assistance.
        </p>
      </div>

      <table class="widthFixed">
        <tr>
          <td>
            <p class="fs10 fw400">Yours Faithfully,</p>
            <p class="fs10 fw400 tal">
              For and on behalf of <b>ASIA INSURANCE CO., LTD</b><br />
              代表亞洲保險有限公司
            </p>
          </td>
        </tr>
        <tr>
          <td class="tal">
            <img style="height:70px;"
              src="data:image/png;base64,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"
              alt="" />

            <p class="fs10 fw400 tal">Authorized Signature<br />Employee Benefits</p>
            <p class="fs10 fw400">Encl.</p>
          </td>
        </tr>
      </table>


    </div>
  </div>
</body>

</html>
  `
}

export { cover_page }
